import { render, staticRenderFns } from "./TicketsIcon.vue?vue&type=template&id=22b5ee12&scoped=true"
var script = {}
import style0 from "./TicketsIcon.vue?vue&type=style&index=0&id=22b5ee12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b5ee12",
  null
  
)

export default component.exports